enum LocalizationFormatName {
    Time = 'timeFormat',
    TimeShort = 'timeShortFormat',
    Date = 'dateFormat',
    DateShort = 'dateShortFormat',
    DateShortMonthDay = 'dateShortMonthDayFormat',
    DateLong = 'dateLongFormat',
    DateTime = 'dateTimeFormat',
}

export default LocalizationFormatName;
